"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  margin-left: 3px;\n  margin-top: 3px;\n  z-index: 2;\n  width: 50px;\n  height: 30px;\n  border: 0;\n  cursor: pointer;\n  border-radius: 5px;\n  background-color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 1.4rem;\n  line-height: 1.8rem;\n  text-align: center;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Handle = function Handle(_ref) {
  var _ref$handle = _ref.handle,
      id = _ref$handle.id,
      value = _ref$handle.value,
      percent = _ref$handle.percent,
      getHandleProps = _ref.getHandleProps,
      handlePrefix = _ref.handlePrefix;
  return _react.default.createElement(StyledHandle, _extends({
    percent: percent
  }, getHandleProps(id)), handlePrefix ? handlePrefix : '', value);
};

var StyledHandle = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var percent = _ref2.percent;
  return "".concat(percent, "%");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.title;
});

Handle.propTypes = {
  handle: _propTypes.object,
  id: _propTypes.string,
  value: _propTypes.number,
  percent: _propTypes.number,
  getHandleProps: _propTypes.object,
  handlePrefix: _propTypes.string
};
var _default = Handle;
exports.default = _default;